exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#orders-table {\n  font-size: 0.8rem;\n}\n#orders-table th {\n  padding: .1rem;\n}\n#orders-table td {\n  padding-bottom: .1rem;\n  padding-top: .1rem;\n  padding-left: .1rem;\n  padding-right: .1rem;\n}\n#orders-table .zn-order-state {\n  line-height: normal;\n  padding-top: 2px;\n}\n.title-row>*:not(h4) {\n  line-height: 1em;\n}\n#zn-page-select .form-group {\n  padding-right: 8px;\n}\n#zn-page-select .form-group label {\n  padding-right: 3px;\n}\n", ""]);

// exports
